import { Box, IconButton, useToast } from "@chakra-ui/react";
import { AppConfig, AppConfigMap } from "common";
import { useEffect, useMemo, useCallback } from "react";
import { FaClipboard } from "react-icons/fa";
import QRCode from "react-qr-code";
import { useAPI } from "../api/useAPI";
import { useAPIQuery } from "../api/useAPIQuery";
import { useToastOnAPIError } from "../api/useToastOnAPIError";

export const AppCodeQRCode = () => {
  const api = useAPI();
  const toast = useToast();
  /*
   * Load app code
   */
  const {
    data: appCode,
    error: appCodeError,
    query: appCodeQuery,
  } = useAPIQuery<"appConfigGet">({
    apiCall: api.appConfigGet,
  });
  useToastOnAPIError({
    error: appCodeError,
    title: `Unable to get app code`,
  });
  useEffect(() => {
    appCodeQuery({ name: AppConfig.AppCode });
  }, [appCodeQuery]);

  /*
   * Build the registerUrl
   */
  const registerUrl = useMemo(
    () =>
      appCode
        ? `${
            window.location.protocol + "//" + window.location.host
          }/register?code=${(appCode as AppConfigMap[AppConfig.AppCode]).code}`
        : undefined,
    [appCode]
  );

  /*
   * Copies app code
   */
  const onCopy = useCallback(() => {
    if (registerUrl) {
      navigator.clipboard.writeText(registerUrl);
      toast({
        position: "top",
        status: "success",
        title: "Successfully copied to clipboard",
      });
    }
  }, [registerUrl, toast]);

  if (!registerUrl) {
    return null;
  }
  return (
    <Box
      width={"100%"}
      display={"flex"}
      flexDir={"column"}
      alignItems={"center"}
    >
      <QRCode value={registerUrl} />
      <Box marginTop={4} display={"flex"} alignItems={"center"}>
        <Box fontSize={"large"} fontWeight={"bold"} marginRight={4}>
          Register URL
        </Box>
        <IconButton
          onClick={onCopy}
          icon={<FaClipboard />}
          aria-label={"Copy Link"}
        />
      </Box>
    </Box>
  );
};
